import { useEffect, useMemo, useState } from 'react';
import { Pages } from '../Core/Enums';
import {Props as LoaderButtonProps } from '../Core/Components/Inputs/LoaderButton/LoaderButton';

import { FooterContainer } from '../Core/Components/Footer/Footer';
import { SlideInOverlay } from '../Core/Components/SlideInOverlay/SlideInOverlay';

import { PlannerPageTable } from './PlannerPageTable/PlannerPageTable';
import { usePlannerPageTableData } from './PlannerPageTable/usePlannerPageTableData';

import './PlannerPage.scss';
import { StoreOrder } from '../Core/SharedTypes/Models';


import { useGetMyLocations } from '../Core/Hooks/LocationHooks';

export const PlannerPage = () => {
   // Get the data for the table
    const tableData = usePlannerPageTableData();
   
    // Get the state for the refresh button
    const refreshButtonState: LoaderButtonProps['state'] = useMemo(() => {
        return tableData.isFetching ? 'loading' : 'idle';
    }, [tableData.isFetching]);

    // State for the slide in overlay
    const [isOpen, setIsOpen] = useState(false);
    const handleSlideIn = async () => {
        setIsOpen(!isOpen);
        setSelectedOrder(null); // Reset selected order for creation view
        
        const result = await tableData.refresh(); // Refresh the table data each time the slide in is closed or opened
	};

    // State for selected order
    const [selectedOrder, setSelectedOrder] = useState<StoreOrder | null>(null);
    const handleOrderClick = (order: StoreOrder) => {

        if(tableData.isLoading || tableData.isFetching){return;}

        setSelectedOrder({...order}); // Set clicked order data
        setIsOpen(!isOpen);
    };
    
    useEffect(() => {
    }, [selectedOrder]);


    return (
        <div className="planner-page">
            <div className="planner-page__header">
                <div className="header-container">
                    <label className="header-container__title">Planlæg bestillinger</label>
                </div>
            </div>

            <div className="store-order-page__content">
                <PlannerPageTable 
                    {...tableData} 
                    handleOrderClick={(order) => handleOrderClick(order)}
                />
            </div>
            <div className="store-order-page__footer">
				<FooterContainer page={Pages.PLANNER_PAGE} />
			</div>
            <SlideInOverlay
                orderData={selectedOrder}
                isOpen={isOpen}
                setIsOpen={() => handleSlideIn()}
            />
        </div>
    );
};
